<ul>
    @for (team of teams; track team) {
<li>{{ team.name }} - {{ team.teamType }}</li>
}
</ul>
<button class="btn btn-primary" (click)="saveMap()">Save map</button>
<div fxLayout="column" class="map" style="border: 2px solid rgb(221, 221, 221);">
    <div fxLayout="row" fxFlex="500px" fxLayoutAlign="center center">
        <svg
            width="100%"
            height="1000"
            viewBox="0 0 500 500"
            #svgGrid
        >
        <!-- "getGroupTransform(shape, i)" -->
         <!-- 'translate(250, ' + (i * 55) + ')' -->
          <!--  [attr.transform]="getGroupTransform(shape, i)" -->
            @for (shape of shapes; track shape; let i = $index) {
<g>
                @if (shape.points === '') {
<rect
                (pointerdown)="downHandleShape($event, shape)"
                (click)="clickHandleShape($event, shape)"
                attr.id="{{ shape.id }}"
                attr.x="{{ shape.positionX - shape.width / 2 }}"
                attr.y="{{ shape.positionY - shape.height / 2 }}"
                attr.width="{{ shape.width }}"
                attr.height="{{ shape.height }}"
                attr.rx="{{ shape.rx }}"
                attr.ry="{{ shape.ry }}"
                attr.stroke="{{shape.strokeColor}}"
                attr.stroke-dasharray="{{shape.strokeDashArray}}"
                attr.fill="{{ shape.color }}"
                ></rect>
}
                
                @if (shape.points !== '') {
<polygon
                (pointerdown)="downHandleShape($event, shape)"
                (click)="clickHandleShape($event, shape)" attr.transform ="translate({{shape.positionX}}, {{shape.positionY }})"
                attr.id="{{ shape.id }}"
                attr.x="{{ shape.positionX - shape.width / 2 }}"
                attr.y="{{ shape.positionY - shape.height / 2 }}"
                attr.width="{{ shape.width }}"
                attr.height="{{ shape.height }}"
                attr.rx="{{ shape.rx }}"
                attr.ry="{{ shape.ry }}"
                attr.stroke="{{shape.strokeColor}}"
                attr.stroke-dasharray="{{shape.strokeDashArray}}"
                attr.fill="{{ shape.color }}"
                attr.points="{{ shape.points }}"
                ></polygon>
}
                <text  
                attr.x="{{ shape.positionX - shape.width / 2 }}"
                attr.y="{{ shape.positionY - shape.height / 100 }}">
                {{ shape.name }}
            </text>
            </g>
}
        </svg>
    </div>
</div>

<div class="map" style="border: 2px solid rgb(221, 221, 221);">
    <svg width="100%" height="500" viewBox="0 0 600 600">

        @for (team of teams; track team; let i = $index) {
<g [attr.transform]="'translate(0, ' + (i * 55) + ')'">
            
            @if (team.teamType === 'Undefined') {
<rect x="0" y="0" width="300" height="25" rx="12.5" fill="#ccc" stroke="#666" stroke-dasharray="2.5,2.5">
                <title>{{ team.name }} - {{ team.teamType }}</title>
            </rect>
}
            @if (team.teamType === 'Stream-Aligned') {
<rect x="0" y="0" width="500" height="25" rx="2.5" fill="#feedb6" stroke="#f9db7d">
                <title>{{ team.name }} - {{ team.teamType }}</title>
            </rect>
}
            @if (team.teamType === 'Complicated-Subsystem') {
<polygon points="6.25,0 18.75,0 25,6.25 25,18.75 18.75,25 6.25,25 0,18.75 0,6.25" fill="#ffc08b" stroke="#e68922">
                <title>{{ team.name }} - {{ team.teamType }}</title>
            </polygon>
}
            @if (team.teamType === 'Platform') {
<rect x="0" y="0" width="500" height="30" fill="#b7cdf2" stroke="#6d9be2">
                <title>{{ team.name }} - {{ team.teamType }}</title>
            </rect>
}
            @if (team.teamType === 'Enabling') {
<rect x="0" y="0" width="25" height="50" fill="#dfbdce" stroke="#d2a1ba">
                <title>{{ team.name }} - {{ team.teamType }}</title>
            </rect>
}
            <text x="30" y="20" font-size="10" fill="black">
                {{ team.name }}
            </text>
        </g>
}
    </svg>
</div>
